function copyToClipboard(text) {
  if (window.clipboardData && window.clipboardData.setData) {
    // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
    return window.clipboardData.setData("Text", text);
  } else if (
    document.queryCommandSupported &&
    document.queryCommandSupported("copy")
  ) {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      return document.execCommand("copy"); // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn("Copy to clipboard failed.", ex);
      return prompt("Copy to clipboard: Ctrl+C, Enter", text);
    } finally {
      document.body.removeChild(textarea);
    }
  }
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

function expiryDate(exseconds) {
  const d = new Date();
  d.setTime(d.getTime() + exseconds * 1000);
  let expires = d.toISOString();
  // alert(expires);
  return expires;
}

function setCookie(cname, cvalue, exseconds) {
  const d = new Date();
  d.setTime(d.getTime() + exseconds * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie =
    cname +
    "=" +
    cvalue +
    ";" +
    expires +
    ";path=/;" +
    "domain=." +
    window.location.host;
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return false;
}

function deleteCookie(name) {
  document.cookie =
    name +
    "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=." +
    window.location.host;
}

function synchronousRequest(url, options) {
  const xhr = new XMLHttpRequest();
  if (options) {
    xhr.open("POST", url, false);
  } else {
    xhr.open("GET", url, false);
  }

  xhr.setRequestHeader("Content-type", "application/json");
  xhr.setRequestHeader(
    "X-Shopify-Storefront-Access-Token",
    "380594134fd4aa4cc9120289b9d85918"
  );

  xhr.send(options);
  if (xhr.status === 200) {
    return xhr.responseText;
  } else {
    throw new Error("Request failed: " + xhr.statusText);
  }
}

class WishlistComponent {
  _migrateGuest(id, callback) {
    if (id && id != "guest" && getCookie("wishlist_data")) {
      let _this = this;
      _this._getLists("guest", true, function () {
        _this._getLists(id, true, function () {
          let guestLists = _this.data["guest"];
          let userLists = _this.data[id];
          Object.keys(guestLists).forEach(function (listId) {
            if (listId != "total") {
              if (userLists[listId]) {
                // Check merging lists
                if (
                  guestLists[listId].name &&
                  (!userLists[listId].name ||
                    guestLists[listId].name != userLists[listId].name)
                ) {
                  _this._updateList(
                    id,
                    guestLists[listId].name,
                    listId,
                    function () {
                      console.log("List name updated");
                    }
                  );
                }
                if (guestLists[listId].data.length) {
                  guestLists[listId].data.forEach(function (item) {
                    let exists = userLists[listId].length
                      ? userLists[listId].data.find(function (userItem) {
                          return (
                            userItem.product_id == item.product_id &&
                            userItem.variant_id == item.variant_id
                          );
                        })
                      : false;
                    if (!exists) {
                      _this._addItem(
                        id,
                        listId,
                        item.product_id,
                        item.variant_id,
                        function () {
                          console.log(
                            "Migrated item!",
                            item.product_id,
                            item.variant_id,
                            "to",
                            listId,
                            "for user",
                            id
                          );
                          guestLists[listId]["data"] = guestLists[listId][
                            "data"
                          ].filter(function (guestItem) {
                            return (
                              guestItem.product_id != item.product_id ||
                              guestItem.variant_id != item.variant_id
                            );
                          });
                          _this._saveData();
                          if (typeof callback == "function") callback();
                        }
                      );
                    }
                  });
                } else {
                  if (typeof callback == "function") callback();
                }
              } else {
                // Check adding lists
                console.log("Add list", guestLists[listId]["name"]);
                _this._addList(
                  id,
                  guestLists[listId]["name"],
                  function (listName, newListId) {
                    if (guestLists[listId].data.length) {
                      guestLists[listId].data.forEach(function (item) {
                        _this._addItem(
                          id,
                          newListId,
                          item.product_id,
                          item.variant_id,
                          function () {
                            console.log(
                              "Migrated item!",
                              item.product_id,
                              item.variant_id,
                              "to",
                              newListId,
                              "for user",
                              id
                            );
                            guestLists[listId]["data"] = guestLists[listId][
                              "data"
                            ].filter(function (guestItem) {
                              return (
                                guestItem.product_id != item.product_id ||
                                guestItem.variant_id != item.variant_id
                              );
                            });
                            _this._saveData();
                            if (typeof callback == "function") callback();
                          }
                        );
                      });
                    } else {
                      if (typeof callback == "function") callback();
                    }
                  }
                );
              }
            }
          });
        });
      });
    }
  }
  _getId() {
    if (window.wishlist_setup.id) {
      return window.wishlist_setup.id;
    } else {
      return "guest";
    }
  }

  _fetch(url, options, callback) {
    try {
      fetch(url, options)
        .then(function (response) {
          return response.json();
        })
        .then(function (res) {
          if (typeof callback == "function") callback(res);
        });
    } catch (error) {
      console.error(error);
    }
  }
  _getRequests() {
    let _this = this;
    return {
      getLists: function (id) {
        return {
          url: "https://iwish.myshopapps.com/API/V1/ShopifyApi/getCategory",
          options: {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              shop_id: window.wishlist_setup.shop_id,
              customer_id: id,
            }),
          },
        };
      },
      getList: function (id, listId, pageNumber) {
        return {
          url: "https://iwish.myshopapps.com/API/V1/ShopifyApi/getWishlistData",
          options: {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              cur_language: window.wishlist_setup.iso_code,
              active_cur: window.wishlist_setup.currency,
              shop_domain: window.wishlist_setup.domain,
              customer_id: id,
              pageNumber: pageNumber,
              category_id: listId,
            }),
          },
        };
      },
      addList: function (id, listName) {
        return {
          url: "https://iwish.myshopapps.com/API/V1/ShopifyApi/saveList",
          options: {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              name: listName,
              shop_id: window.wishlist_setup.shop_id,
              customer_id: id,
            }),
          },
        };
      },
      updateList: function (id, listName, listId) {
        return {
          url: "https://iwish.myshopapps.com/API/V1/ShopifyApi/updateCategory",
          options: {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              shop_id: window.wishlist_setup.shop_id,
              name: listName,
              customer_id: id,
              id: listId,
            }),
          },
        };
      },
      deleteList: function (id, listId) {
        return {
          url: "https://iwish.myshopapps.com/API/V1/ShopifyApi/deleteCategory",
          options: {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              shop_domain: window.wishlist_setup.domain,
              shop_id: window.wishlist_setup.shop_id,
              customer_id: id,
              id: listId,
            }),
          },
        };
      },

      addItem: function (id, listId, productId, variantId) {
        return {
          url: "https://api.myshopapps.com/wishlist/V1/addToWishlist/",
          options: {
            method: "POST",
            headers: {
              xtoken: window.wishlist_setup.token,
              "Content-Type": "application/x-www-form-urlencoded",
              Accept: "application/json",
            },
            body: new URLSearchParams({
              customer_id: id,
              product_id: productId,
              variant_id: variantId,
              category_id: listId,
              product_qty: 1,
            }),
          },
        };
      },
      removeItem: function (id, listId, productId, variantId) {
        return {
          url: "https://iwish.myshopapps.com/API/V1/ShopifyApi/deleteWishlistData",
          options: {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              customer_id: id,
              product_id: productId,
              variant_id: variantId,
              category_id: listId,
            }),
          },
        };
      },
    };
  }
  _saveData() {
    let _this = this;
    let cookieData = JSON.stringify(_this.data);
    setCookie("wishlist_data", cookieData, 60 * 60 * 24 * 2); // 2 days to expire
    setTimeout(function () {
      window.dispatchEvent(
        new CustomEvent("wishlist:update", { detail: _this.data })
      );
    }, 0);
  }
  _getData() {
    if (getCookie("wishlist_data"))
      return JSON.parse(getCookie("wishlist_data"));
    return {};
  }

  _getLists(id, syncEach, callback) {
    let _this = this;
    if (id == "guest") {
      if (typeof callback == "function") callback();
    } else {
      if (!_this.data[id]) _this.data[id] = {};
      _this.running = true;
      let fetchItem = _this.requests.getLists(id);
      _this._fetch(fetchItem.url, fetchItem.options, function (res) {
        _this.data[id]["total"] = res.totalCount;

        if (res.data && res.data.length > 0) {
          if (syncEach) _this._getListData(id, 0, false);
          res.data.forEach(function (list, i) {
            console.log("list", list);
            if (!_this.data[id][list.id]) _this.data[id][list.id] = {};
            _this.data[id][list.id]["name"] = list.name;
            if (syncEach)
              _this._getListData(id, list.id, i + 1 == res.data.length);
          });
          if (!syncEach) {
            _this._saveData();
            //_this.running = false;
          }
        } else if (res.totalCount > 0) {
          if (syncEach) {
            _this._getListData(id, 0, true);
          } else {
            //_this.running = false;
          }
        } else {
          _this.data[id][0] = {};
          _this.data[id][0]["data"] = [];
          //_this._getListData(id, 0, true);
          _this._saveData();
        }
        if (typeof callback == "function") callback();
      });
    }
  }

  _getListData(id, listId, isLast, callback) {
    let _this = this;
    if (id == "guest") {
      if (typeof callback == "function") callback(_this.data[id][listId]);
    } else {
      _this._getList(id, listId, 1, function (data) {
        if (typeof callback == "function") callback(data);
        if (isLast) {
          _this._saveData();
        }
      });
    }
  }

  _getList(id, listId, pageNumber, callback) {
    let _this = this;
    if (!_this.data[id]) _this.data[id] = {};
    if (!_this.data[id][listId]) _this.data[id][listId] = {};

    if (id == "guest") {
      if (typeof callback == "function") callback(_this.data[id][listId]);
    } else {
      _this.running = true;
      if (pageNumber == 1) _this.data[id][listId]["data"] = [];
      let fetchItem = this.requests.getList(id, listId, pageNumber);
      _this._fetch(fetchItem.url, fetchItem.options, function (res) {
        if (res.data && res.data.length > 0) {
          res.data.forEach(function (resEl) {
            _this.data[id][listId]["data"].push({
              product_id: resEl.product_id,
              variant_id: resEl.variant_id,
            });
          });
        }
        if (parseInt(res.offset) < parseInt(res.totalCount)) {
          // Get next page
          _this._getList(id, listId, pageNumber + 1, callback);
        } else {
          // Loop ended!
          if (typeof callback == "function") callback(_this.data[id][listId]);
        }
      });
    }
  }
  _addList(id, listName, callback) {
    let _this = this;
    if (id == "guest") {
      let listId = Object.keys(_this.data[id]).length;
      _this.data[id][listId] = {};
      _this.data[id][listId]["name"] = listName;
      _this.data[id][listId]["data"] = [];
      _this._saveData();
      if (typeof callback == "function") callback(listName, listId);
    } else {
      let fetchItem = this.requests.addList(id, listName);
      this._fetch(fetchItem.url, fetchItem.options, function (res) {
        _this._getLists(id, false, function () {
          let thisListId = false;
          Object.keys(_this.data[id]).forEach(function (listId) {
            if (
              _this.data[id][listId] &&
              _this.data[id][listId]["name"] &&
              _this.data[id][listId]["name"].trim() == listName.trim()
            ) {
              thisListId = listId;
            }
          });
          if (thisListId) {
            if (typeof callback == "function") callback(listName, thisListId);
          }
        });
      });
    }
  }
  _updateList(id, listName, listId, callback) {
    let _this = this;
    if (id == "guest") {
      _this.data[id][listId]["name"] = listName;
      _this._saveData();
      if (typeof callback == "function") callback(listName, listId, res);
    } else {
      let fetchItem = this.requests.updateList(id, listName, listId);
      this._fetch(fetchItem.url, fetchItem.options, function (res) {
        _this.data[id][listId]["name"] = listName;
        _this._saveData();
        _this._getListData(id, listId, true);
        if (typeof callback == "function") callback(listName, listId, res);
      });
    }
  }
  _deleteList(id, listId, callback) {
    let _this = this;
    if (id == "guest") {
      delete _this.data[id][listId];
      _this._saveData();
      if (typeof callback == "function") callback(listId, res);
    } else {
      let fetchItem = this.requests.deleteList(id, listId);
      this._fetch(fetchItem.url, fetchItem.options, function (res) {
        delete _this.data[id][listId];
        _this._saveData();
        if (typeof callback == "function") callback(listId, res);
      });
    }
  }
  _removeItem(id, listId, productId, variantId, callback) {
    let _this = this;
    if (id == "guest") {
      _this.data[id][listId]["data"] = _this.data[id][listId]["data"].filter(
        function (item) {
          return item.product_id != productId || item.variant_id != variantId;
        }
      );
      let total = 0;
      Object.keys(_this.data[id]).forEach(function (listId) {
        if (listId != "total") {
          total += _this.data[id][listId]["data"].length;
        }
      });
      _this.data[id].total = total;
      _this._saveData();
      if (typeof callback == "function") callback(listId, productId, variantId);
    } else {
      let fetchItem = this.requests.removeItem(
        id,
        listId,
        productId,
        variantId
      );
      _this._fetch(fetchItem.url, fetchItem.options, function (res) {
        _this._getLists(id);
        _this._getListData(id, listId, true);
        if (typeof callback == "function")
          callback(listId, productId, variantId);
      });
    }
  }
  _addItem(id, listId, productId, variantId, callback) {
    let _this = this;
    if (!_this.data[id][listId]["data"]) _this.data[id][listId]["data"] = [];
    if (id == "guest") {
      _this.data[id][listId]["data"].push({
        variant_id: variantId,
        product_id: productId,
      });
      let total = 0;
      Object.keys(_this.data[id]).forEach(function (listId) {
        if (listId != "total") {
          total += _this.data[id][listId]["data"].length;
        }
      });
      _this.data[id].total = total;
      _this._saveData();
      if (typeof callback == "function") callback(listId, productId, variantId);
    } else {
      let fetchItem = this.requests.addItem(id, listId, productId, variantId);
      this._fetch(fetchItem.url, fetchItem.options, function (res) {
        _this.data[id][listId]["data"].push({
          variant_id: variantId,
          product_id: productId,
        });
        _this._getLists(id);
        setTimeout(function () {
          _this._getListData(id, listId, true);
        }, 0);
        if (typeof callback == "function")
          callback(listId, productId, variantId);
      });
    }
  }
  getData(id) {
    if (!id) id = this.id;
    let data = this._getData();
    return data[id] || {};
  }
  getLists(callback) {
    this._getLists(this.id, true, callback);
  }
  getList(listId, pageNumber, callback) {
    this._getList(this.id, listId, pageNumber, callback);
  }
  addList(listName, callback) {
    this._addList(this.id, listName, callback);
  }
  updateList(listName, listId, callback) {
    this._updateList(this.id, listName, listId, callback);
  }
  deleteList(listId, callback) {
    this._deleteList(this.id, listId, callback);
  }
  removeItem(listId, productId, variantId, callback) {
    this._removeItem(this.id, listId, productId, variantId, callback);
  }
  addItem(listId, productId, variantId, callback) {
    this._addItem(this.id, listId, productId, variantId, callback);
  }
  constructor() {
    this.id = this._getId();
    this.requests = this._getRequests();
    this.data = this._getData();
    let _this = this;
    if (this.id == "guest" && !this.data["guest"])
      this.data["guest"] = { 0: { data: [] }, total: 0 };

    if (getCookie("user_fingerprint")) {
      let userFpData = this.getData(getCookie("user_fingerprint"));
      let newObj = { guest: {} };
      newObj["guest"] = userFpData;
      this.data = newObj;
      this._saveData();
      deleteCookie("user_fingerprint");
    }

    if (this.id != "guest" && this.data["guest"]) {
      this._migrateGuest(window.wishlist_setup.id, function () {
        if (window.wishlist_setup.id && _this.data["guest"]) {
          let hasAnyList = Object.keys(_this.data["guest"]).filter(function (
            listId
          ) {
            return _this.data["guest"][listId]?.data?.length > 0;
          }).length;
          if (!hasAnyList) {
            _this.data["guest"] = { 0: { data: [] }, total: 0 };
            _this._saveData();
          }
        }
        _this.getLists();
      });
    } else {
      _this._saveData();
      this.getLists();
    }
  }
}
let MyWishlist = new WishlistComponent();

document.addEventListener("DOMContentLoaded", (e) => {
  class WishlistCount extends HTMLElement {
    constructor() {
      self = super();
      let _this = this;
      _this.counter = this;
      _this.renderCount();
      window.addEventListener("wishlist:update", function () {
        _this.renderCount();
      });
    }
    renderCount() {
      let data = MyWishlist.getData();
      if (this.counter && data && typeof data["total"] !== "undefined") {
        this.counter.innerHTML = data["total"];
      }
    }
  }
  customElements.define("wishlist-count", WishlistCount);

  class WishlistNavigation extends HTMLElement {
    constructor() {
      self = super();
      let _this = this;
      _this.nav = _this;
      _this.renderNav();
      window.addEventListener("wishlist:update", function () {
        _this.renderNav();
      });
    }
    renderNav() {
      let data = MyWishlist.getData();
      let _this = this;
      if (data && _this.nav.tagName) {
        this.innerHTML = "";
        let id = MyWishlist.id;
        let listIds = Object.keys(data);
        let navHtml = "";
        let isButton = _this.nav.getAttribute("data-button");
        let isNav = _this.nav.getAttribute("data-navigation");
        let isPage = _this.nav.getAttribute("data-page");
        navHtml = `<div class="sub-nav-inner ${
          isButton ? "wishlist-popup-inner" : ""
        }">
          ${
            isButton
              ? `<span class="heart wishlist-popup-icon"></span>
          <p class="title">${window.wishlist_setup.add_to_fav}</p>
          <p>${window.wishlist_setup.select_list}</p>`
              : ""
          }
          ${
            isPage && !isNav
              ? `<h1 class="title">${window.wishlist_setup.global_name}</h1> ${
                  !window.wishlist_setup.id ||
                  window.wishlist_setup.id == "guest"
                    ? `<p class="wishlist-not-logged-notice">${window.wishlist_setup.not_logged}</p>`
                    : ""
                } `
              : ""
          }
          <ul class="wishlist-navigation sub-nav-list child-nav child-nav--dropdown">`;

        if (listIds.length) {
          let iter = 2;
          Object.keys(data).forEach(function (listId) {
            if (["total"].indexOf(listId) == -1) {
              let name = window.wishlist_setup.default_list;
              let url = "/pages/wishlist";
              if (listId != 0) {
                url += "?list=" + listId;
              }
              if (data[listId].name) {
                name = data[listId].name;
              }
              navHtml += "<li class='wishlist-navigation__item'>";
              if (isButton) {
                navHtml += `<wishlist-item-list class="wishlist-navigation__link child-nav__item" data-list-id="${listId}">
                  <span class="sub-nav-item-link-title">${name}</span>
                </wishlist-item-list>`;
              } else {
                let isActiveUrl = false;
                if (
                  window.location.pathname.indexOf("/pages/wishlist") > -1 &&
                  window.location.search.indexOf("list=" + listId) > -1 &&
                  listId != 0
                )
                  isActiveUrl = true;
                if (
                  listId == 0 &&
                  window.location.search.indexOf("list=") == -1
                )
                  isActiveUrl = true;

                navHtml += `<a class="wishlist-navigation__link main-nav__item child-nav__item${
                  isActiveUrl ? " active" : ""
                }" data-list-id="${listId}" href="${url}">
                  ${name}
                </a>`;
                if (isPage && !isNav) {
                  navHtml +=
                    '<button class="wishlist-share-url" href="' +
                    "https://" +
                    window.location.host +
                    "/pages/wishlist?id=" +
                    id +
                    "&list=" +
                    listId +
                    '"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.3,13.35a1,1,0,0,1-.7-.29,1,1,0,0,1,0-1.41l2.12-2.12a2,2,0,0,0,0-2.83L17.3,5.28a2.06,2.06,0,0,0-2.83,0L12.35,7.4A1,1,0,0,1,10.94,6l2.12-2.12a4.1,4.1,0,0,1,5.66,0l1.41,1.41a4,4,0,0,1,0,5.66L18,13.06A1,1,0,0,1,17.3,13.35Z" fill="currentColor"/><path d="M8.11,21.3a4,4,0,0,1-2.83-1.17L3.87,18.72a4,4,0,0,1,0-5.66L6,10.94A1,1,0,0,1,7.4,12.35L5.28,14.47a2,2,0,0,0,0,2.83L6.7,18.72a2.06,2.06,0,0,0,2.83,0l2.12-2.12A1,1,0,1,1,13.06,18l-2.12,2.12A4,4,0,0,1,8.11,21.3Z" fill="currentColor"/><path d="M8.82,16.18a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42l6.37-6.36a1,1,0,0,1,1.41,0,1,1,0,0,1,0,1.42L9.52,15.89A1,1,0,0,1,8.82,16.18Z" fill="currentColor"/></svg></button>';

                  navHtml += `<div class="wishlist-popup wishlist-popup-share"><div class="wishlist-popup-inner"><span class="wishlist-popup-icon">
                  <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 7.83333L10.1053 16L24 2" stroke="#5F4096" stroke-width="3" stroke-linecap="round"/>
</svg>

                    </span><div class="title">${window.wishlist_setup.link_copied}</div><div class="buttons"><button class="btn btn-cancel">${window.wishlist_setup.continue}</button></div></div></div>`;

                  if (listId != 0) {
                    let editIcon = `<svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.59806 2.3875L8.61247 3.40192L9.11968 2.89471L8.10527 1.88029L7.59806 2.3875ZM7.59806 4.41634L6.58365 3.40192L1.49309 8.49246L1.4649 9.53506L2.50751 9.50694L7.59806 4.41634ZM5.82281 2.13389L7.8517 0.105047C7.87458 0.0821143 7.8999 0.0629336 7.92673 0.0475043C8.02278 -0.00771379 8.13898 -0.0147935 8.24026 0.026265C8.28345 0.0437744 8.3239 0.0700349 8.35891 0.105047L10.8949 2.64111C11.035 2.78117 11.035 3.00825 10.8949 3.14831L8.86611 5.17715L3.21876 10.8245C3.15388 10.8894 3.06658 10.9269 2.97484 10.9294L0.368347 10.9999C0.162732 11.0054 -0.00541828 10.8373 0.000133651 10.6317L0.0705803 8.02513C0.0730622 7.93339 0.110613 7.84609 0.1755 7.78125L5.82281 2.13389Z" fill="currentColor"/>
                    </svg>`;
                    navHtml += `<button class="wishlist-edit-btn">${editIcon}</button>`;

                    navHtml += `<div class="wishlist-popup wishlist-popup-edit"><wishlist-edit-list class="wishlist__edit-list wishlist-popup-inner" data-list-id="${listId}"><span class="wishlist-popup-icon">${editIcon}</span><div class="title">${window.wishlist_setup.change_list_name}</div><form class="wishlist__edit-list-form"><input type="text" value="${name}"/><div class="buttons"><button type="submit" class="btn btn-submit">${window.wishlist_setup.rename}</button><button type="button" class="btn btn-cancel">${window.wishlist_setup.cancel}</button></div></form></wishlist-edit-list></div>`;

                    navHtml += `<button class="wishlist-remove-btn"><svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.41177 1.61333H7.5V1.17333C7.5 0.862145 7.37605 0.563703 7.15542 0.343661C6.93479 0.123618 6.63555 0 6.32353 0H3.67647C3.36445 0 3.06521 0.123618 2.84458 0.343661C2.62395 0.563703 2.5 0.862145 2.5 1.17333V1.61333H0.588235C0.432226 1.61333 0.282606 1.67514 0.17229 1.78516C0.0619747 1.89518 0 2.0444 0 2.2C0 2.35559 0.0619747 2.50481 0.17229 2.61483C0.282606 2.72485 0.432226 2.78666 0.588235 2.78666H0.773529L1.4 9.66679C1.43348 10.0322 1.60307 10.3718 1.87532 10.6186C2.14756 10.8654 2.50268 11.0015 2.87059 11H7.13529C7.5032 11.0015 7.85832 10.8654 8.13057 10.6186C8.40281 10.3718 8.57241 10.0322 8.60588 9.66679L9.22647 2.78666H9.41177C9.56777 2.78666 9.71739 2.72485 9.82771 2.61483C9.93803 2.50481 10 2.35559 10 2.2C10 2.0444 9.93803 1.89518 9.82771 1.78516C9.71739 1.67514 9.56777 1.61333 9.41177 1.61333ZM3.67647 1.17333H6.32353V1.61333H3.67647V1.17333ZM7.42794 9.55972C7.42132 9.63286 7.38743 9.70085 7.33297 9.75027C7.27851 9.7997 7.20745 9.82695 7.13382 9.82666H2.86912C2.79549 9.82695 2.72443 9.7997 2.66997 9.75027C2.61551 9.70085 2.58163 9.63286 2.575 9.55972L1.95441 2.78666H8.04559L7.42794 9.55972Z" fill="currentColor"/>
                </svg></button>`;
                    navHtml += `<div class="wishlist-popup wishlist-popup-remove"><div class="wishlist-popup-inner"><span class="wishlist-popup-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="26" viewBox="0 0 24 26" fill="none">
                <path d="M22.5882 3.81333H18V2.77333C18 2.0378 17.7025 1.33239 17.173 0.812289C16.6435 0.292189 15.9253 0 15.1765 0H8.82353C8.07468 0 7.35651 0.292189 6.82699 0.812289C6.29748 1.33239 6 2.0378 6 2.77333V3.81333H1.41176C1.03734 3.81333 0.678254 3.95942 0.413497 4.21947C0.148739 4.47952 0 4.83223 0 5.19999C0 5.56776 0.148739 5.92046 0.413497 6.18051C0.678254 6.44056 1.03734 6.58666 1.41176 6.58666H1.85647L3.36 22.8488C3.44034 23.7125 3.84737 24.5152 4.50076 25.0986C5.15415 25.6819 6.00643 26.0036 6.88941 26H17.1247C18.0077 26.0036 18.86 25.6819 19.5134 25.0986C20.1667 24.5152 20.5738 23.7125 20.6541 22.8488L22.1435 6.58666H22.5882C22.9627 6.58666 23.3217 6.44056 23.5865 6.18051C23.8513 5.92046 24 5.56776 24 5.19999C24 4.83223 23.8513 4.47952 23.5865 4.21947C23.3217 3.95942 22.9627 3.81333 22.5882 3.81333ZM8.82353 2.77333H15.1765V3.81333H8.82353V2.77333ZM17.8271 22.5957C17.8112 22.7686 17.7298 22.9293 17.5991 23.0461C17.4684 23.1629 17.2979 23.2273 17.1212 23.2266H6.88588C6.70917 23.2273 6.53863 23.1629 6.40793 23.0461C6.27724 22.9293 6.1959 22.7686 6.18 22.5957L4.69059 6.58666H19.3094L17.8271 22.5957Z" fill="#5F4096"/>
                </svg>
                </span><div class="title">${window.wishlist_setup.delete_confirm}</div><p>${name}</p><div class="buttons"><wishlist-remove-list class="wishlist__remove-list btn btn-submit" data-list-id="${listId}">${window.wishlist_setup.delete}</wishlist-remove-list><button class="btn btn-cancel">${window.wishlist_setup.do_not_delete}</button></div></div></div>`;
                  }
                }
              }

              navHtml += "</li>";
            }
          });
          if (!isNav) {
            navHtml += `<li class="wishlist-navigation__item wishlist-navigation__add sub-nav-item">
            <button class="sub-nav-item-link-title btn wishlist__add-list__btn">${
              window.wishlist_setup.add_list
            }</button>
            <div class="wishlist-popup-add-list wishlist-popup">
              <div class="wishlist-popup-inner">
              <span class="wishlist-popup-icon">+</span>
              <div class="title">${window.wishlist_setup.add_list}</div>
              <wishlist-add-list class="wishlist__add-list" ${
                isPage ? 'data-page="1"' : ""
              }>
                <form class="wishlist__add-list__form">
                  <input placeholder="List name" class="wishlist__add-list__input" type="text" id='listName' />
                  <div class="buttons">
                    <button class="wishlist__add-list__submit btn btn-submit" type="submit">${
                      window.wishlist_setup.add
                    }</button>
                    <button class="btn btn-cancel" type="button">${
                      window.wishlist_setup.cancel
                    }</button>
                  </div>
                </form>
                </wishlist-add-list>
              </div>
            </div>

            </li>`;
          }
        }

        navHtml += `</ul>
        ${
          isButton
            ? `<div class="buttons">
        <button class="btn btn-submit">${window.wishlist_setup.confirm}</button>
        <button class="btn btn-cancel">${window.wishlist_setup.cancel}</button>
        </div>`
            : ""
        }
        </div>`;
        this.innerHTML = navHtml;
      }
    }
  }
  customElements.define("wishlist-navigation", WishlistNavigation);

  document.addEventListener("click", function (e) {
    if (
      !e.target.closest(".wishlist-popup-inner") ||
      e.target.closest(`.btn-cancel`)
    ) {
      if (e.target.closest(".wishlist-popup-inner .wishlist-navigation__add")) {
        e.stopImmediatePropagation();
        document
          .querySelectorAll(".wishlist__add-list__btn.active")
          .forEach(function (el) {
            el.classList.remove("active");
          });
      } else {
        document
          .querySelectorAll(
            ".wishlist-edit-btn.active, .wishlist-remove-btn.active, .wishlist-share-url.active, .wishlist__add-list__btn.active"
          )
          .forEach(function (el) {
            el.classList.remove("active");
          });
      }
    }

    if (e.target.closest(".wishlist-share-url")) {
      e.preventDefault();
      e.stopPropagation();
      let url = e.target.closest(".wishlist-share-url").getAttribute("href");
      copyToClipboard(url);
      e.target.closest(".wishlist-share-url").classList.add("active");
      setTimeout(function () {
        e.target.closest(".wishlist-share-url").classList.remove("active");
      }, 3000);
    }

    if (
      e.target.closest(
        ".wishlist__add-list__btn" ||
          e.target.classList.contains("wishlist__add-list__btn")
      )
    ) {
      e.preventDefault();
      e.stopPropagation();
      let target = e.target;
      if (e.target.classList.contains("wishlist__add-list__btn"))
        target = e.target.closest(".wishlist__add-list__btn");

      target.classList.add("active");
    }

    //wishlist__add-list__btn

    if (e.target.closest(".wishlist-edit-btn")) {
      e.preventDefault();
      e.stopPropagation();
      e.target.closest(".wishlist-edit-btn").classList.add("active");
    }
    if (e.target.closest(".wishlist-remove-btn")) {
      e.preventDefault();
      e.stopPropagation();
      e.target.closest(".wishlist-remove-btn").classList.add("active");
    }
  });

  
  function renderPrice(item) {
    /*
    <div class="price price--sale-color price--top" bis_skin_checked="1">
            <div class="price__default" bis_skin_checked="1">
              <span class="price__current">$4.59</span>
              <s class="price__was"></s>
            </div>
            <div class="price__no-variant" hidden="" bis_skin_checked="1">
              <span class="price__current">Unavailable</span>
            </div>
          </div>
          */
    if (
      item.compareAtPrice &&
      item.compareAtPrice.amount &&
      item.compareAtPrice.amount > item.price.amount
    ) {
      return `<div class="price price--sale-color price--top price--on-sale"><div class="price__default">
      <span class="price__current">$${parseFloat(item.price.amount).toFixed(
        2
      )}</span>
        <s class="price__was">$${parseFloat(
          item.compareAtPrice.amount
        ).toFixed(2)}</s>
      </div></div>`;
    } else {
      return `<div class="price price--sale-color price--top"><div class="price__default">
      <span class="price__current">$${parseFloat(item.price.amount).toFixed(
        2
      )}</span>
      </div></div>`;
    }
    /*
    if (item.compareAtPrice && item.compareAtPrice.amount && item.compareAtPrice.amount > item.price.amount ) {
      return `<div class="price align-center on-sale">
      <span class="amount theme-money">${theme.Shopify.formatMoney(
        item.price.amount,
        theme.money_format
      )}</span>
        <del><span class="theme-money">${theme.Shopify.formatMoney(
          item.compareAtPrice.amount,
          theme.money_format
        )}</span></del>
      </div>`;
    } else {
      return `<div class="price align-center">
      <span class="amount theme-money">${theme.Shopify.formatMoney(
        item.price.amount,
        theme.money_format
      )}</span>
      </div>`;
    }
    */
  }

  /*
  function renderImages(item) {
    let images = item.product.images.nodes;
    let imageHtml = "";
    let hasSecondary = false;
    if (images.length > 1) {
      hasSecondary = true;
    }
    imageHtml += `<div class="image image--shape-natural ${
      hasSecondary ? `image--with-secondary` : ""
    }">`;
    imageHtml += `<div class="inner">`;
    imageHtml += `<a href="/products/${item.product.handle}" aria-label="${item.product.title}">`;
    imageHtml += `<div class="image__primary">`;
    imageHtml += `<div class="rimage-outer-wrapper" style="max-width: 3000px">`;
    imageHtml += `<div class="rimage-wrapper " style="padding-top:100.0%">`;
    imageHtml += `<img class="rimage__image fade-in lazyloaded" alt="${images[0].altText}" src="${images[0].url}">`;
    imageHtml += `</div>`;
    imageHtml += `</div>`;
    imageHtml += `</div>`;
    if (hasSecondary) {
      imageHtml += `<div class="image__secondary">`;
      imageHtml += `<img class="rimage-outer-wrapper fade-in lazyloaded" alt="${images[1].altText}" src="${images[1].url}">`;
      imageHtml += `</div>`;
    }
    imageHtml += `</a>`;
    imageHtml += `</div>`;
    imageHtml += `</div>`;
    return imageHtml;
  }
  */

  /*
  function renderProduct(item, listId) {
    return `<div class="product-block layout-align-above align-center flex column max-cols-3 min-cols-2">
    <div class="product-block__inner">
      <wishlist-button data-product-id="${item.product.id}" data-variant-id="${
      item.id
    }" ${
      MyWishlist.isPreview
        ? ""
        : `data-list-id="${listId == "button" ? "0" : listId}"`
    }>
        <span class="heart"></span>
      </wishlist-button>
      ${
        listId == "button"
          ? `<wishlist-navigation
          class="wishlist-popup"
  ${
    MyWishlist.isPreview
      ? ""
      : `data-list-id="${listId == "button" ? "0" : listId}"`
  }
  data-button="true"
  data-product-id="${item.product.id}"
  data-variant-id="${item.id}"
  ></wishlist-navigation>`
          : ""
      }
      ${renderImages(item)}
      <div class="product-block__title-price">
        <a class="title align-center" href="/products/${item.product.handle}">
          <h3>
          ${item.product.title}
          </h3>
        </a>
        ${renderPrice(item)}
      </div>
      <form method="post" action="/cart/add" id="product_form_${
        item.product.id
      }" accept-charset="UTF-8" class="product-form product-form--mini" enctype="multipart/form-data" data-ajax-add-to-cart="false" data-product-id="${
      item.product.id
    }">
        <input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">
        <input type="hidden" name="quantity" value="1">
        <input type="hidden" name="id" value="${item.id}">
        <button type="submit" name="add" class="btn product-add">${
          window.wishlist_setup.atc
        }</button>
        <input type="hidden" name="product-id" value="${item.product.id}">
      </form>
    
      <div class="themed-product-reviews">
        <span class="shopify-product-reviews-badge" data-id="${
          item.product.id
        }"></span>
      </div>
    </div>
  </div>`;
  }
  */

  function renderImages(item) {
    let images = item.product.images.nodes;
    let imageHtml = "";
    let hasSecondary = false;
    if (images.length > 1) {
      hasSecondary = true;
    }
    imageHtml += '<div class="card__media relative';
    if (hasSecondary) imageHtml += " has-hover-image";
    imageHtml += '">';
    imageHtml += `<a href="/products/${item.product.handle}" aria-label="${item.product.title}" class="media block relative js-prod-link" style="padding-top: 100.0%;" tabindex="-1">`;
    imageHtml += `<img data-srcset="${images[0].url}" sizes="(min-width: 1838px) calc((1710px - 48px) / 3), (min-width: 1280px) calc((100vw - 176px) / 3), (min-width: 600px) calc((100vw - 120px) / 2), calc(100vw - 40px)" data-src="${images[0].url}" src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%201200%201200'%3E%3C/svg%3E" class="img-fit img-fit--contain card__main-image no-js-hidden" data-media-id="${item.product.id}" loading="lazy" width="1200" height="1200" alt="${item.product.title}" srcset="${images[0].url}">`;
    if (hasSecondary) {
      imageHtml += `<img data-srcset="${images[1].url}" sizes="(min-width: 1838px) calc((1710px - 48px) / 3), (min-width: 1280px) calc((100vw - 176px) / 3), (min-width: 600px) calc((100vw - 120px) / 2), calc(100vw - 40px)" data-src="${images[1].url}" src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%201200%201200'%3E%3C/svg%3E" class="img-fit img-fit--contain card__hover-image no-js-hidden" data-media-id="${item.product.id}" loading="lazy" width="1200" height="1200" alt="${item.product.title}" srcset="${images[1].url}">`;
    }
    imageHtml += `</a>`;
    imageHtml += `</div>`;
    return imageHtml;
  }

  function renderProduct(item, listId) {
    return `<li class="js-pagination-result"><product-card class="card card--product h-full card--no-lines relative flex">
    <wishlist-button data-product-id="${item.product.id}" data-variant-id="${
      item.id
    }" ${
      MyWishlist.isPreview
        ? ""
        : `data-list-id="${listId == "button" ? "0" : listId}"`
    }>
        <span class="heart"></span>
      </wishlist-button>
      ${
        listId == "button"
          ? `<wishlist-navigation
          class="wishlist-popup"
  ${
    MyWishlist.isPreview
      ? ""
      : `data-list-id="${listId == "button" ? "0" : listId}"`
  }
  data-button="true"
  data-product-id="${item.product.id}"
  data-variant-id="${item.id}"
  ></wishlist-navigation>`
          : ""
      }

    ${renderImages(item)}

    <div class="card__info-container flex flex-col flex-auto relative" bis_skin_checked="1">
      <div class="card__info w-full" bis_skin_checked="1">
        <div class="card__info-inner inline-block text-center w-full" bis_skin_checked="1">
        <div class="card__title mt-1 mb-0" bis_skin_checked="1">
            <a href="/products/${
              item.product.handle
            }" class="card-link text-current js-prod-link">
              <h3>${item.product.title}</h3>
            </a>
          </div>
          ${renderPrice(item)}
          
        </div>
      </div><div class="card__quick-add mob:card__quick-add--below desktop:card__quick-add--below" bis_skin_checked="1"><product-form class="relative text-center" data-variant-id="${
        item.id
      }" data-show-quantity-selector="false">
              <div class="alert mb-8 bg-error-bg text-error-text js-form-error text-start" role="alert" hidden="" bis_skin_checked="1"></div><form method="post" action="/cart/add" id="quick-add-${
                item.product.id
              }" accept-charset="UTF-8" class="js-product-form" enctype="multipart/form-data" novalidate="novalidate"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">
              
              <input type="hidden" name="id" value="${
                item.id
              }"><button class="btn btn--primary w-full btn--atc" data-add-to-cart-text="Add to cart" name="add" aria-haspopup="dialog">
                    <span class="quick-add-btn-icon">
                      <span class="visually-hidden">Add to cart</span>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M12.12 20.44H5.6V9.56h12.8v3.73c.06.4.4.69.8.7.44 0 .8-.35.8-.8v-4.5a.792.792 0 0 0-.8-.69H17V6.5C16.9 4 14.7 2 12 2S7 4.09 7 6.67V8H4.71c-.4.04-.71.37-.71.78v12.53a.8.8 0 0 0 .8.69h7.43c.38-.06.67-.39.67-.78 0-.43-.35-.78-.78-.78ZM8.66 6.67c0-1.72 1.49-3.11 3.33-3.11s3.33 1.39 3.33 3.11V8H8.65V6.67Z"></path><path d="M20 17.25h-2.4v-2.5a.817.817 0 0 0-.8-.7c-.44 0-.8.36-.8.8v2.4h-2.5c-.4.06-.7.4-.7.8 0 .44.36.8.8.8H16v2.5c.06.4.4.7.8.7.44 0 .8-.36.8-.8v-2.4h2.5c.4-.06.69-.4.7-.8 0-.44-.35-.8-.8-.8Z"></path></svg>
                    </span>
                    <span class="quick-add-btn-text">Add to cart</span>
                  </button>

                
                  
<quantity-input class="inline-block">
  <label class="label visually-hidden" for="quantity-template--wishlist-page__collection-products">Qty</label>
  <div class="qty-input qty-input--combined inline-flex items-center w-full" bis_skin_checked="1">
    <button type="button" class="qty-input__btn btn btn--minus no-js-hidden" name="minus">
      <span class="visually-hidden">-</span>
    </button>
    <input type="number" class="qty-input__input input" id="quantity-template--wishlist-page__collection-products" name="updates[]" min="0" value="0" data-index="1" data-initial-value="0" aria-label="Quantity" data-variant-id="${
      item.id
    }">
    <button type="button" class="qty-input__btn btn btn--plus no-js-hidden" name="plus">
      <span class="visually-hidden">+</span>
    </button>
  </div>
</quantity-input>

                  <div class="alert mt-6 bg-error-bg text-error-text js-product-form-errors" role="alert" hidden="" bis_skin_checked="1"></div>
                

                <a href="/products/${
                  item.product.handle
                }" class="btn btn--secondary quick-add-view-btn">View details</a><input type="hidden" name="product-id" value="${
      item.product.id
    }"><input type="hidden" name="section-id" value="template--wishlist-page__collection-products"></form></product-form></div></div>
  </product-card></li>`;
  }

  function prepareProducts(items, listId) {
    let queriedVariants = [];
    let renderedVariants = [];

    let pageHtml = `<ul class="grid mb-8 md:mb-12 grid-cols-2 small-cards-mobile sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-card" style="">`;

    let query = `query GetProduct {
    `;
    items.forEach(function (item, i) {
      if (
        item &&
        item.variant_id &&
        queriedVariants.indexOf(item.variant_id) == -1
      ) {
        queriedVariants.push(item.variant_id);
        query += `variant_${item.variant_id}: node(id: "${btoa(
          "gid://shopify/ProductVariant/" + item.variant_id
        )}") {
          ... on ProductVariant {
            quantityAvailable
            title
            price{
              amount
              currencyCode
            }
            compareAtPrice {
              amount
              currencyCode
            }
            product {
              handle
              title
              images(first: 5) {
                nodes {
                  id
                  width
                  height
                  url
                  altText
                }
              }
            }
          }
        }`;
      }
    });
    query += "}";

    let productData = synchronousRequest(
      "/api/2024-01/graphql.json",
      JSON.stringify({ query: query })
    );
    productData = JSON.parse(productData)["data"];

    items.forEach(function (item) {
      if (
        item &&
        item.variant_id &&
        renderedVariants.indexOf(item.variant_id) == -1
      ) {
        renderedVariants.push(item.variant_id);
        let variantDataSelector = "variant_" + item.variant_id;
        let productDataItem = productData[variantDataSelector];
        if (productDataItem) {
          productDataItem.id = item.variant_id;
          productDataItem.product.id = item.product_id;
          if (item && productDataItem) {
            let productHtml = renderProduct(productDataItem, listId);
            pageHtml += productHtml;
          }
        } else {
          console.log("WishlistItem was deleted from store", productDataItem);
        }
      }
    });
    pageHtml += "</ul>";
    return pageHtml;
  }

  class WishlistPage extends HTMLElement {
    constructor() {
      super();
      this.renderPage();
      //window.addEventListener("wishlist:update", this.renderPage);
    }
    renderPage() {
      let _this = this;
      let listId = 0;
      let data = false;
      let id = MyWishlist.id;

      if (getUrlParameter("list")) {
        listId = parseInt(getUrlParameter("list"));
      }

      let pageHtml = false;
      if (getUrlParameter("id")) {
        MyWishlist.isPreview = true;

        let title = "";
        MyWishlist._getLists(getUrlParameter("id"), false, function () {
          MyWishlist._getList(
            getUrlParameter("id"),
            listId,
            1,
            function (wdata) {
              if (wdata && _this.tagName) {
                //_this.innerHTML = "";
                title = `<h1>${window.wishlist_setup.shared_list_prefix} ${
                  wdata.name ? wdata.name : window.wishlist_setup.default_list
                }</h1>`;
                pageHtml = title + prepareProducts(wdata["data"], "button");
                _this.innerHTML = pageHtml;
              }
            }
          );
        });
      } else {
        MyWishlist._getListData(id, listId, 1, function (wdata) {
          let title = `<h1>${
            wdata.name ? wdata.name : window.wishlist_setup.default_list
          }</h1>`;

          if (wdata && wdata["data"] && wdata["data"].length && _this.tagName) {
            let listId = 0;
            if (getUrlParameter("list"))
              listId = parseInt(getUrlParameter("list"));
            pageHtml = title + prepareProducts(wdata["data"], listId);
            _this.innerHTML = pageHtml;
          } else {
            _this.innerHTML =
              title +
              `<svg class="empty-svg" width="601" height="401" viewBox="0 0 601 401" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_4_124)">
              <path d="M601 0H0V401H601V0Z" fill="white"/>
              <path d="M21.2612 245.467C21.2612 228.093 38.0452 212.957 62.8775 204.999C69.2911 201.78 90.4944 190.018 97.7144 171.949C104.635 154.629 102.235 137.06 101.223 118.984C95.8443 22.861 220.398 14.0009 288.006 28.0018C304.639 31.4464 320.985 36.2524 336.878 42.2433C378.019 57.75 413.735 83.9132 448.815 109.844C473.083 127.783 500.802 140.619 529.615 149.331C548.675 155.095 583.24 163.172 583.24 189.076C583.241 227.462 518.315 229.896 493.001 231.739C489.376 232.003 485.598 232.313 482.488 234.195C458.045 248.981 503.026 273.643 512.651 279.086C529.703 288.728 549.795 307.453 545.817 329.277C539.363 364.686 484.381 369.641 456.744 370.896C403.008 373.335 350.971 354.855 296.949 358.237C277.655 359.445 258.139 361.229 239.416 366.246C207.507 374.798 153.815 396.787 131.529 358.157C122.861 343.133 133.653 318.303 119.071 306.986C100.852 292.848 78.8921 291.298 57.8561 284.325C41.4258 278.878 21.2612 264.703 21.2612 245.467Z" fill="url(#paint0_linear_4_124)" fill-opacity="0.32"/>
              <path d="M349.378 196.021L345.74 192.209C345.696 192.169 345.638 192.107 345.582 192.043L345.34 191.728C345.041 191.255 344.896 190.759 344.896 190.255C344.896 188.766 346.108 187.553 347.596 187.553C348.255 187.553 348.872 187.788 349.359 188.214C349.845 187.789 350.463 187.553 351.122 187.553C352.61 187.553 353.822 188.766 353.822 190.255C353.822 190.76 353.678 191.257 353.403 191.692L353.142 192.035C353.062 192.127 353.021 192.171 352.977 192.213L349.378 196.021ZM347.595 188.555C346.658 188.555 345.897 189.318 345.897 190.255C345.897 190.57 345.988 190.881 346.162 191.157L346.356 191.406C346.37 191.42 346.406 191.46 346.445 191.498L349.374 194.565L352.567 191.137C352.733 190.866 352.821 190.562 352.821 190.254C352.821 189.317 352.058 188.554 351.122 188.554C350.584 188.554 350.088 188.807 349.762 189.247L349.36 189.789L348.958 189.247C348.63 188.808 348.134 188.555 347.595 188.555Z" fill="#D2C5EA"/>
              <path d="M321.064 143.862L317.667 140.304C317.628 140.27 317.574 140.212 317.521 140.15L317.294 139.855C317.01 139.408 316.874 138.941 316.874 138.468C316.874 137.068 318.013 135.928 319.412 135.928C320.021 135.928 320.592 136.142 321.045 136.528C321.497 136.142 322.068 135.928 322.678 135.928C324.077 135.928 325.215 137.068 325.215 138.468C325.215 138.942 325.079 139.409 324.821 139.818L324.578 140.139C324.494 140.235 324.459 140.273 324.42 140.309L321.064 143.862ZM319.413 136.93C318.566 136.93 317.877 137.62 317.877 138.468C317.877 138.752 317.96 139.034 318.116 139.284L318.294 139.514C318.303 139.521 318.335 139.557 318.371 139.591L321.061 142.408L323.712 139.601L324.161 139.857L323.792 139.519L323.987 139.266C324.135 139.022 324.214 138.747 324.214 138.469C324.214 137.621 323.525 136.931 322.679 136.931C322.192 136.931 321.743 137.16 321.45 137.558L321.048 138.101L320.645 137.558C320.347 137.16 319.899 136.93 319.413 136.93Z" fill="#D2C5EA"/>
              <path d="M434.169 70.7855L428.817 65.1765C428.747 65.1133 428.665 65.0241 428.584 64.9319L428.227 64.4657C427.81 63.8061 427.604 63.0983 427.604 62.3805C427.604 60.2542 429.332 58.5249 431.456 58.5249C432.475 58.5249 433.425 58.9209 434.142 59.6287C434.858 58.9209 435.808 58.5249 436.828 58.5249C438.952 58.5249 440.681 60.2552 440.681 62.3805C440.681 63.0983 440.474 63.8071 440.082 64.4276L439.699 64.9319C439.593 65.0512 439.535 65.1143 439.472 65.1735L434.169 70.7855ZM431.455 59.5294C429.883 59.5294 428.604 60.8096 428.604 62.3825C428.604 62.9108 428.757 63.4341 429.047 63.8963L429.357 64.2963C429.395 64.3374 429.456 64.4036 429.521 64.4657L434.165 69.3318L438.763 64.4667C438.827 64.4046 438.867 64.3615 438.907 64.3163L439.246 63.8762C439.528 63.4191 439.679 62.9038 439.679 62.3825C439.679 60.8096 438.399 59.5294 436.827 59.5294C435.923 59.5294 435.092 59.9535 434.544 60.6923L434.142 61.2357L433.741 60.6923C433.191 59.9525 432.358 59.5294 431.455 59.5294Z" fill="#D2C5EA"/>
              <path d="M345.424 382.463L340.206 376.996C340.14 376.934 340.059 376.848 339.98 376.759L339.63 376.303C339.221 375.657 339.02 374.966 339.02 374.266C339.02 372.191 340.708 370.502 342.782 370.502C343.773 370.502 344.697 370.886 345.396 371.57C346.093 370.885 347.017 370.502 348.008 370.502C350.082 370.502 351.77 372.191 351.77 374.266C351.77 374.966 351.569 375.658 351.187 376.265L351.16 376.304L350.812 376.758C350.712 376.869 350.655 376.933 350.591 376.993L345.424 382.463ZM342.783 371.503C341.261 371.503 340.023 372.742 340.023 374.265C340.023 374.777 340.171 375.284 340.453 375.732L340.753 376.121C340.789 376.158 340.847 376.224 340.911 376.283L345.421 381.008L349.884 376.285C349.947 376.224 349.987 376.178 350.029 376.134L350.353 375.713C350.626 375.27 350.771 374.771 350.771 374.266C350.771 372.743 349.533 371.504 348.01 371.504C347.136 371.504 346.329 371.914 345.799 372.63L345.398 373.173L344.996 372.63C344.464 371.913 343.658 371.503 342.783 371.503Z" fill="#D2C5EA"/>
              <path d="M74.3857 95.4729L64.7096 85.3356C64.5733 85.2103 64.4301 85.0539 64.2869 84.8935L63.6378 84.0454C62.9256 82.9176 62.563 81.6765 62.563 80.4184C62.563 76.6901 65.594 73.6565 69.3202 73.6565C71.2555 73.6565 73.0494 74.4715 74.3326 75.9131C75.6167 74.4715 77.4107 73.6565 79.3459 73.6565C83.0711 73.6565 86.1022 76.6901 86.1022 80.4184C86.1022 81.6765 85.7396 82.9176 85.0534 84.0083L85.0264 84.0464L84.2921 84.9938C84.192 85.104 84.0928 85.2133 83.9846 85.3166L74.3857 95.4729ZM69.3192 74.659C66.146 74.659 63.5637 77.2424 63.5637 80.4184C63.5637 81.487 63.8732 82.5437 64.4591 83.474L65.0591 84.2569C65.1573 84.3652 65.2785 84.4985 65.4117 84.6238L74.3807 94.0193L83.2755 84.6078C83.3836 84.5035 83.4658 84.4123 83.5479 84.3211L84.217 83.4539C84.794 82.5286 85.0995 81.479 85.0995 80.4184C85.0995 77.2424 82.5182 74.659 79.3449 74.659C77.5189 74.659 75.8391 75.5141 74.7342 77.0048L74.3316 77.5482L73.9289 77.0048C72.8261 75.5141 71.1453 74.659 69.3192 74.659Z" fill="#D2C5EA"/>
              <path d="M168.799 62.5679L163.779 57.3078C163.715 57.2497 163.637 57.1665 163.561 57.0802L163.226 56.6411C162.832 56.0176 162.638 55.3509 162.638 54.6762C162.638 52.6733 164.265 51.0442 166.267 51.0442C167.215 51.0442 168.102 51.4091 168.773 52.0607C169.444 51.4091 170.33 51.0442 171.28 51.0442C173.28 51.0442 174.908 52.6733 174.908 54.6762C174.908 55.3519 174.714 56.0186 174.346 56.6041L173.986 57.0772C173.884 57.1915 173.83 57.2507 173.772 57.3068L168.799 62.5679ZM166.266 52.0477C164.817 52.0477 163.638 53.2266 163.638 54.6773C163.638 55.1635 163.78 55.6457 164.047 56.0717L164.334 56.4437C164.366 56.4777 164.421 56.5389 164.482 56.595L168.795 61.1123L173.061 56.598C173.12 56.5409 173.156 56.4998 173.193 56.4587L173.508 56.0507C173.767 55.6296 173.904 55.1544 173.904 54.6752C173.904 53.2256 172.726 52.0457 171.278 52.0457C170.446 52.0457 169.678 52.4367 169.174 53.1174L168.772 53.6607L168.369 53.1174C167.865 52.4377 167.099 52.0477 166.266 52.0477Z" fill="#D2C5EA"/>
              <path d="M68.5419 281.621L58.8658 271.484C58.7296 271.359 58.5863 271.201 58.4431 271.041L57.795 270.194C57.0828 269.066 56.7202 267.824 56.7202 266.566C56.7202 262.836 59.7513 259.804 63.4775 259.804C65.4127 259.804 67.2067 260.618 68.4898 262.06C69.7739 260.619 71.5679 259.804 73.5031 259.804C77.2283 259.804 80.2594 262.836 80.2594 266.566C80.2594 267.824 79.8968 269.066 79.2096 270.157L79.1836 270.195L78.5175 271.063C78.3532 271.248 78.252 271.36 78.1409 271.463L68.5419 281.621ZM63.4765 260.805C60.3032 260.805 57.7209 263.389 57.7209 266.565C57.7209 267.633 58.0304 268.69 58.6164 269.621L59.2164 270.402C59.3145 270.51 59.4357 270.645 59.569 270.769L68.5379 280.165L77.4327 270.753C77.5439 270.648 77.626 270.556 77.7101 270.461L78.3742 269.601C78.9522 268.675 79.2567 267.625 79.2567 266.565C79.2567 263.389 76.6754 260.805 73.5021 260.805C71.6761 260.805 69.9953 261.661 68.8915 263.152L68.4888 263.695L68.0861 263.152C66.9823 261.661 65.3025 260.805 63.4765 260.805Z" fill="#D2C5EA"/>
              <path d="M530.825 96.8313L521.15 86.693C521.014 86.5687 520.871 86.4113 520.727 86.2509L520.078 85.4038C519.367 84.275 519.004 83.0329 519.004 81.7758C519.004 78.0475 522.034 75.0139 525.761 75.0139C527.695 75.0139 529.49 75.8289 530.774 77.2705C532.057 75.8289 533.852 75.0139 535.786 75.0139C539.513 75.0139 542.543 78.0475 542.543 81.7758C542.543 83.0329 542.18 84.274 541.494 85.3657L541.468 85.4048L540.801 86.274C540.637 86.4574 540.535 86.5697 540.425 86.674L530.825 96.8313ZM525.761 76.0154C522.587 76.0154 520.006 78.5989 520.006 81.7748C520.006 82.8424 520.316 83.9001 520.901 84.8314L521.502 85.6123C521.6 85.7206 521.72 85.8539 521.854 85.9783L530.823 95.3757L539.718 85.9642C539.829 85.858 539.912 85.7647 539.996 85.6725L540.659 84.8123C541.236 83.886 541.542 82.8364 541.542 81.7758C541.542 78.5999 538.961 76.0164 535.787 76.0164C533.962 76.0164 532.282 76.8715 531.177 78.3623L530.775 78.9046L530.373 78.3623C529.267 76.8705 527.586 76.0154 525.761 76.0154Z" fill="#D2C5EA"/>
              <path d="M147.411 226.186L128.465 206.336C128.184 206.075 127.909 205.773 127.634 205.465L126.362 203.802C125.017 201.668 124.32 199.282 124.32 196.867C124.32 189.702 130.145 183.873 137.304 183.873C141.211 183.873 144.821 185.604 147.308 188.644C149.794 185.604 153.404 183.873 157.312 183.873C164.471 183.873 170.295 189.702 170.295 196.867C170.295 199.283 169.598 201.668 168.279 203.765L168.252 203.803L166.799 205.677C166.612 205.881 166.427 206.085 166.226 206.277L147.411 226.186ZM137.305 184.874C130.698 184.874 125.322 190.253 125.322 196.866C125.322 199.093 125.967 201.293 127.186 203.23L128.408 204.828C128.637 205.084 128.889 205.362 129.169 205.622L147.408 224.731L165.518 205.57C165.721 205.377 165.889 205.191 166.058 205.004L166.156 204.896L167.445 203.213C168.656 201.28 169.296 199.087 169.296 196.867C169.296 190.254 163.921 184.875 157.314 184.875C153.511 184.875 150.012 186.654 147.713 189.758L147.31 190.302L146.907 189.758C144.607 186.654 141.107 184.874 137.305 184.874Z" fill="#D2C5EA"/>
              <path d="M487.746 166.8L467.138 145.208C466.831 144.923 466.533 144.597 466.236 144.262L464.852 142.451C463.394 140.137 462.636 137.547 462.636 134.923C462.636 127.142 468.961 120.811 476.736 120.811C480.997 120.811 484.934 122.707 487.634 126.036C490.335 122.707 494.271 120.811 498.532 120.811C506.307 120.811 512.633 127.142 512.633 134.923C512.633 137.547 511.875 140.137 510.441 142.414L510.415 142.452L508.853 144.471C508.645 144.701 508.439 144.929 508.214 145.144L487.746 166.8ZM476.736 121.814C469.513 121.814 463.637 127.694 463.637 134.923C463.637 137.358 464.342 139.764 465.674 141.88L467.007 143.624C467.26 143.906 467.537 144.212 467.841 144.495L487.742 165.344L507.504 144.435C507.73 144.22 507.919 144.01 508.109 143.799L508.199 143.7L509.606 141.861C510.93 139.75 511.63 137.351 511.63 134.923C511.63 127.694 505.754 121.814 498.531 121.814C494.375 121.814 490.549 123.76 488.035 127.152L487.633 127.695L487.232 127.152C484.718 123.76 480.894 121.814 476.736 121.814Z" fill="#D2C5EA"/>
              <path d="M484.639 285.638L471.33 271.694C471.138 271.515 470.943 271.303 470.748 271.085L469.854 269.916C468.894 268.392 468.4 266.703 468.4 264.993C468.4 259.916 472.526 255.787 477.599 255.787C480.305 255.787 482.81 256.96 484.567 259.027C486.324 256.961 488.829 255.787 491.536 255.787C496.608 255.787 500.734 259.916 500.734 264.993C500.734 266.704 500.24 268.393 499.305 269.879L499.279 269.917L498.269 271.221C498.133 271.372 497.998 271.519 497.851 271.659L484.639 285.638ZM477.599 256.788C473.079 256.788 469.402 260.469 469.402 264.992C469.402 266.513 469.842 268.017 470.675 269.344L471.52 270.446C471.668 270.612 471.841 270.802 472.032 270.98L484.635 284.184L497.141 270.951C497.288 270.809 497.407 270.678 497.526 270.548L498.469 269.325C499.295 268.004 499.732 266.507 499.732 264.993C499.732 260.47 496.054 256.789 491.535 256.789C488.935 256.789 486.542 258.007 484.968 260.131L484.566 260.674L484.165 260.131C482.592 258.006 480.198 256.788 477.599 256.788Z" fill="#D2C5EA"/>
              <path d="M357.4 316.758C357.776 316.159 358.004 315.455 358.004 314.694C358.004 312.547 356.264 310.805 354.118 310.805C352.838 310.805 351.712 311.433 351.004 312.388C350.296 311.433 349.17 310.805 347.89 310.805C345.744 310.805 344.004 312.547 344.004 314.694C344.004 315.455 344.231 316.159 344.608 316.758L344.997 317.267C345.079 317.36 345.161 317.45 345.251 317.534L351.035 323.594L356.785 317.511C356.856 317.444 356.92 317.372 356.985 317.298L357.4 316.758Z" fill="white"/>
              <path d="M396.657 272.849C397.034 272.249 397.261 271.545 397.261 270.784C397.261 268.637 395.521 266.896 393.376 266.896C392.095 266.896 390.97 267.523 390.262 268.479C389.554 267.523 388.428 266.896 387.148 266.896C385.003 266.896 383.263 268.637 383.263 270.784C383.263 271.545 383.489 272.249 383.867 272.849L384.255 273.358C384.337 273.45 384.42 273.54 384.51 273.625L390.293 279.685L396.043 273.601C396.114 273.534 396.178 273.462 396.243 273.389L396.657 272.849Z" fill="#8D77B6"/>
              <path d="M312.503 255.418C313.057 254.538 313.286 253.433 312.95 252.254C312.564 250.902 311.419 249.835 310.044 249.55C308.431 249.217 306.964 249.892 306.107 251.048C305.251 249.892 303.783 249.217 302.171 249.55C300.794 249.836 299.651 250.902 299.265 252.254C298.929 253.433 299.159 254.538 299.712 255.418L300.1 255.927C300.182 256.02 300.265 256.11 300.355 256.194L306.138 262.254L311.888 256.171C311.959 256.104 312.023 256.032 312.088 255.958L312.503 255.418Z" fill="#8D77B6"/>
              <path d="M462.533 340.177C462.91 339.578 463.137 338.874 463.137 338.113C463.137 335.966 461.398 334.225 459.252 334.225C457.972 334.225 456.846 334.852 456.139 335.808C455.431 334.852 454.305 334.225 453.026 334.225C450.88 334.225 449.14 335.966 449.14 338.113C449.14 338.874 449.367 339.578 449.744 340.177L450.133 340.687C450.215 340.779 450.297 340.869 450.387 340.953L456.171 347.014L461.92 340.93C461.992 340.863 462.056 340.791 462.121 340.718L462.533 340.177Z" fill="#8D77B6"/>
              <path d="M371.444 169.629C371.942 168.837 372.242 167.907 372.242 166.901C372.242 164.063 369.944 161.762 367.108 161.762C365.416 161.762 363.929 162.592 362.993 163.855C362.057 162.592 360.57 161.762 358.878 161.762C356.042 161.762 353.744 164.063 353.744 166.901C353.744 167.907 354.043 168.837 354.542 169.629L355.055 170.302C355.163 170.424 355.272 170.543 355.391 170.655L363.035 178.663L370.634 170.624C370.727 170.534 370.812 170.439 370.898 170.343L371.444 169.629Z" fill="#8D77B6"/>
              <path d="M251.955 233.032C252.619 231.977 253.018 230.738 253.018 229.399C253.018 225.619 249.956 222.555 246.179 222.555C243.926 222.555 241.944 223.66 240.698 225.342C239.452 223.66 237.471 222.555 235.218 222.555C231.441 222.555 228.38 225.62 228.38 229.399C228.38 230.737 228.779 231.977 229.443 233.032L230.126 233.927C230.27 234.09 230.415 234.249 230.574 234.396L240.753 245.062L250.873 234.354C250.999 234.236 251.111 234.109 251.226 233.981L251.955 233.032Z" fill="#5F4096"/>
              <path d="M356.652 213.972C357.11 213.245 357.384 212.391 357.384 211.468C357.384 208.864 355.275 206.753 352.673 206.753C351.12 206.753 349.755 207.514 348.896 208.672C348.038 207.514 346.673 206.753 345.12 206.753C342.518 206.753 340.408 208.864 340.408 211.468C340.408 212.391 340.683 213.245 341.14 213.972L341.611 214.589C341.71 214.702 341.811 214.811 341.92 214.913L348.934 222.262L355.907 214.885C355.993 214.804 356.07 214.716 356.15 214.627L356.652 213.972Z" fill="#D2C5EA"/>
              <path d="M371.336 236.078C371.539 235.754 371.661 235.375 371.661 234.964C371.661 233.805 370.723 232.866 369.565 232.866C368.875 232.866 368.267 233.205 367.885 233.72C367.504 233.205 366.896 232.866 366.205 232.866C365.047 232.866 364.109 233.805 364.109 234.964C364.109 235.374 364.231 235.754 364.434 236.078L364.644 236.352C364.688 236.403 364.733 236.451 364.781 236.496L367.901 239.765L371.003 236.483C371.041 236.447 371.076 236.408 371.112 236.368L371.336 236.078Z" fill="#D2C5EA"/>
              <path d="M330.34 248.287C330.543 247.963 330.665 247.584 330.665 247.173C330.665 246.015 329.727 245.075 328.569 245.075C327.879 245.075 327.271 245.414 326.889 245.929C326.507 245.414 325.899 245.075 325.209 245.075C324.051 245.075 323.113 246.015 323.113 247.173C323.113 247.583 323.235 247.963 323.438 248.287L323.648 248.562C323.692 248.612 323.736 248.66 323.785 248.706L326.905 251.975L330.007 248.693C330.045 248.657 330.08 248.618 330.115 248.579L330.34 248.287Z" fill="#D2C5EA"/>
              <path d="M385.26 176.584C385.464 176.261 385.586 175.882 385.586 175.471C385.586 174.312 384.647 173.372 383.489 173.372C382.799 173.372 382.191 173.711 381.81 174.226C381.428 173.711 380.82 173.372 380.13 173.372C378.972 173.372 378.033 174.312 378.033 175.471C378.033 175.881 378.155 176.261 378.359 176.584L378.568 176.859C378.612 176.909 378.657 176.957 378.705 177.003L381.826 180.273L384.928 176.99C384.966 176.954 385.001 176.915 385.036 176.876L385.26 176.584Z" fill="#D2C5EA"/>
              <path d="M412.354 151.896C412.557 151.573 412.68 151.193 412.68 150.782C412.68 149.623 411.741 148.684 410.583 148.684C409.893 148.684 409.285 149.023 408.903 149.538C408.522 149.023 407.914 148.684 407.223 148.684C406.066 148.684 405.127 149.623 405.127 150.782C405.127 151.192 405.249 151.572 405.453 151.896L405.662 152.171C405.706 152.221 405.751 152.269 405.799 152.315L408.919 155.584L412.021 152.302C412.059 152.266 412.095 152.227 412.13 152.188L412.354 151.896Z" fill="#D2C5EA"/>
              <path d="M350.858 155.346C351.061 155.023 351.183 154.643 351.183 154.232C351.183 153.073 350.245 152.134 349.087 152.134C348.397 152.134 347.789 152.472 347.407 152.988C347.026 152.472 346.418 152.134 345.727 152.134C344.569 152.134 343.631 153.073 343.631 154.232C343.631 154.642 343.753 155.022 343.956 155.346L344.166 155.62C344.21 155.67 344.255 155.718 344.303 155.765L347.423 159.034L350.525 155.752C350.563 155.715 350.598 155.676 350.634 155.637L350.858 155.346Z" fill="#D2C5EA"/>
              <path d="M318.021 155.346C318.224 155.023 318.346 154.643 318.346 154.232C318.346 153.073 317.408 152.134 316.25 152.134C315.56 152.134 314.952 152.472 314.57 152.988C314.189 152.472 313.581 152.134 312.89 152.134C311.732 152.134 310.794 153.073 310.794 154.232C310.794 154.642 310.916 155.022 311.119 155.346L311.329 155.62C311.373 155.67 311.418 155.718 311.466 155.765L314.586 159.034L317.688 155.752C317.726 155.715 317.762 155.676 317.797 155.637L318.021 155.346Z" fill="#D2C5EA"/>
              <path d="M217.488 176.818C218.337 175.468 218.848 173.882 218.848 172.168C218.848 167.33 214.929 163.407 210.094 163.407C207.211 163.407 204.674 164.821 203.08 166.974C201.485 164.821 198.949 163.407 196.065 163.407C191.231 163.407 187.312 167.329 187.312 172.168C187.312 173.882 187.822 175.468 188.672 176.818L189.546 177.965C189.731 178.173 189.916 178.376 190.12 178.565L203.15 192.217L216.102 178.512C216.262 178.361 216.406 178.197 216.554 178.034L217.488 176.818Z" fill="#5F4096"/>
              <path d="M238.934 284.16C239.598 283.105 239.996 281.866 239.996 280.527C239.996 276.746 236.934 273.683 233.158 273.683C230.905 273.683 228.924 274.787 227.678 276.47C226.432 274.787 224.451 273.683 222.198 273.683C218.42 273.683 215.358 276.747 215.358 280.527C215.358 281.865 215.757 283.105 216.421 284.16L217.104 285.055C217.249 285.217 217.394 285.377 217.552 285.524L227.732 296.19L237.852 285.482C237.977 285.364 238.089 285.236 238.204 285.109L238.934 284.16Z" fill="#DECCFF"/>
              <path d="M251.955 141.805C252.619 140.75 253.018 139.511 253.018 138.172C253.018 134.391 249.956 131.328 246.178 131.328C243.926 131.328 241.944 132.432 240.698 134.114C239.452 132.431 237.471 131.328 235.218 131.328C231.441 131.328 228.38 134.392 228.38 138.172C228.38 139.51 228.779 140.749 229.443 141.805L230.126 142.7C230.27 142.862 230.415 143.021 230.574 143.169L240.753 153.836L250.873 143.128C250.999 143.01 251.111 142.882 251.226 142.755L251.955 141.805Z" fill="#5F4096"/>
              <path d="M303.195 284.673C303.891 283.566 304.309 282.267 304.309 280.863C304.309 276.897 301.097 273.683 297.135 273.683C294.773 273.683 292.693 274.842 291.386 276.606C290.079 274.842 288 273.683 285.637 273.683C281.675 273.683 278.463 276.898 278.463 280.863C278.463 282.267 278.882 283.566 279.578 284.673L280.295 285.612C280.447 285.783 280.599 285.949 280.765 286.105L291.445 297.293L302.061 286.061C302.192 285.937 302.31 285.804 302.431 285.67L303.195 284.673Z" fill="#DECCFF"/>
              <path d="M185.566 257.635C186.391 256.323 186.887 254.782 186.887 253.118C186.887 248.42 183.081 244.61 178.386 244.61C175.585 244.61 173.122 245.983 171.574 248.074C170.025 245.983 167.562 244.61 164.761 244.61C160.067 244.61 156.26 248.42 156.26 253.118C156.26 254.782 156.756 256.323 157.581 257.635L158.431 258.748C158.61 258.951 158.79 259.147 158.988 259.332L171.643 272.591L184.223 259.281C184.378 259.133 184.518 258.975 184.662 258.817L185.566 257.635Z" fill="#5F4096"/>
              <path d="M364.399 107.483C364.776 106.884 365.003 106.18 365.003 105.419C365.003 103.272 363.263 101.53 361.118 101.53C359.838 101.53 358.712 102.158 358.004 103.113C357.295 102.158 356.169 101.53 354.89 101.53C352.745 101.53 351.005 103.272 351.005 105.419C351.005 106.18 351.231 106.884 351.609 107.483L351.998 107.992C352.08 108.085 352.162 108.175 352.252 108.259L358.036 114.319L363.785 108.236C363.856 108.169 363.92 108.097 363.985 108.023L364.399 107.483Z" fill="#C09CFF"/>
              <path d="M132.781 351.461C133.251 350.716 133.532 349.839 133.532 348.893C133.532 346.22 131.368 344.053 128.696 344.053C127.104 344.053 125.702 344.834 124.821 346.023C123.939 344.833 122.539 344.053 120.945 344.053C118.275 344.053 116.109 346.22 116.109 348.893C116.109 349.839 116.392 350.716 116.861 351.461L117.343 352.095C117.446 352.21 117.548 352.323 117.66 352.427L124.859 359.969L132.015 352.398C132.103 352.315 132.182 352.224 132.264 352.134L132.781 351.461Z" fill="#8D77B6"/>
              <path d="M566.969 174.109C567.346 173.51 567.574 172.806 567.574 172.045C567.574 169.898 565.834 168.156 563.688 168.156C562.408 168.156 561.282 168.784 560.574 169.739C559.866 168.784 558.74 168.156 557.46 168.156C555.314 168.156 553.574 169.898 553.574 172.045C553.574 172.806 553.801 173.51 554.178 174.109L554.567 174.619C554.649 174.711 554.731 174.801 554.821 174.885L560.605 180.945L566.354 174.862C566.426 174.795 566.49 174.723 566.555 174.65L566.969 174.109Z" fill="#8D77B6"/>
              <path d="M338.95 233.249C339.327 232.649 339.554 231.945 339.554 231.185C339.554 229.037 337.814 227.296 335.668 227.296C334.388 227.296 333.262 227.923 332.555 228.879C331.847 227.923 330.721 227.296 329.442 227.296C327.297 227.296 325.557 229.037 325.557 231.185C325.557 231.945 325.783 232.649 326.161 233.249L326.549 233.758C326.631 233.85 326.714 233.94 326.804 234.025L332.587 240.085L338.337 234.002C338.408 233.934 338.472 233.862 338.537 233.789L338.95 233.249Z" fill="#8D77B6"/>
              <path d="M355.291 139.341C355.669 138.741 355.895 138.037 355.895 137.276C355.895 135.129 354.155 133.388 352.01 133.388C350.73 133.388 349.604 134.015 348.896 134.971C348.187 134.015 347.062 133.388 345.782 133.388C343.637 133.388 341.897 135.129 341.897 137.276C341.897 138.037 342.123 138.741 342.501 139.341L342.89 139.85C342.972 139.942 343.054 140.032 343.144 140.116L348.928 146.177L354.677 140.093C354.748 140.026 354.812 139.954 354.878 139.881L355.291 139.341Z" fill="#8D77B6"/>
              <path d="M292.356 191.655C292.733 191.056 292.96 190.352 292.96 189.591C292.96 187.443 291.22 185.702 289.075 185.702C287.795 185.702 286.669 186.33 285.961 187.285C285.252 186.33 284.127 185.702 282.846 185.702C280.701 185.702 278.961 187.443 278.961 189.591C278.961 190.352 279.187 191.056 279.565 191.655L279.954 192.164C280.036 192.256 280.118 192.347 280.208 192.431L285.992 198.491L291.741 192.408C291.812 192.341 291.876 192.269 291.942 192.195L292.356 191.655Z" fill="#8D77B6"/>
              <path d="M437.339 201.498C437.527 201.198 437.64 200.846 437.64 200.466C437.64 199.392 436.771 198.521 435.697 198.521C435.057 198.521 434.494 198.835 434.14 199.313C433.787 198.835 433.224 198.521 432.584 198.521C431.511 198.521 430.641 199.391 430.641 200.466C430.641 200.846 430.754 201.198 430.942 201.498L431.136 201.752C431.178 201.798 431.219 201.844 431.264 201.886L434.155 204.915L437.03 201.874C437.065 201.841 437.097 201.803 437.13 201.767L437.339 201.498Z" fill="#D2C5EA"/>
              <path d="M324.811 294.473C325 294.173 325.113 293.821 325.113 293.441C325.113 292.367 324.243 291.496 323.171 291.496C322.531 291.496 321.968 291.81 321.614 292.288C321.26 291.81 320.698 291.496 320.057 291.496C318.985 291.496 318.115 292.366 318.115 293.441C318.115 293.821 318.228 294.173 318.417 294.473L318.611 294.727C318.652 294.773 318.693 294.818 318.738 294.86L321.63 297.891L324.505 294.849C324.54 294.815 324.572 294.779 324.605 294.743L324.811 294.473Z" fill="#C09CFF"/>
              <path d="M375.758 300.435C375.946 300.136 376.06 299.784 376.06 299.404C376.06 298.33 375.19 297.459 374.116 297.459C373.476 297.459 372.913 297.773 372.56 298.251C372.206 297.773 371.643 297.459 371.003 297.459C369.93 297.459 369.061 298.329 369.061 299.404C369.061 299.784 369.174 300.136 369.363 300.435L369.557 300.69C369.598 300.736 369.639 300.781 369.684 300.823L372.576 303.853L375.451 300.811C375.486 300.777 375.518 300.741 375.551 300.705L375.758 300.435Z" fill="#C09CFF"/>
              <path d="M299.828 230.271C300.016 229.972 300.13 229.62 300.13 229.24C300.13 228.166 299.26 227.296 298.186 227.296C297.546 227.296 296.983 227.61 296.63 228.088C296.276 227.61 295.713 227.296 295.073 227.296C294 227.296 293.13 228.166 293.13 229.24C293.13 229.62 293.243 229.972 293.431 230.271L293.626 230.526C293.667 230.572 293.708 230.617 293.753 230.659L296.645 233.689L299.52 230.647C299.555 230.613 299.587 230.577 299.62 230.541L299.828 230.271Z" fill="#D2C5EA"/>
              <path d="M407.099 233.469C407.287 233.17 407.4 232.818 407.4 232.438C407.4 231.364 406.531 230.493 405.457 230.493C404.817 230.493 404.254 230.807 403.9 231.285C403.547 230.807 402.984 230.493 402.344 230.493C401.271 230.493 400.4 231.363 400.4 232.438C400.4 232.818 400.514 233.17 400.702 233.469L400.896 233.724C400.937 233.77 400.978 233.815 401.023 233.857L403.915 236.888L406.79 233.846C406.825 233.812 406.857 233.776 406.89 233.74L407.099 233.469Z" fill="#D2C5EA"/>
              <path d="M331.428 95.1312C331.616 94.8315 331.729 94.4796 331.729 94.0996C331.729 93.026 330.86 92.1548 329.786 92.1548C329.146 92.1548 328.583 92.4686 328.229 92.9468C327.876 92.4686 327.313 92.1548 326.673 92.1548C325.6 92.1548 324.729 93.0249 324.729 94.0996C324.729 94.4796 324.843 94.8315 325.031 95.1312L325.225 95.3858C325.266 95.432 325.307 95.4771 325.353 95.5192L328.244 98.5487L331.119 95.5071C331.154 95.4731 331.186 95.437 331.219 95.4009L331.428 95.1312Z" fill="#5F4096"/>
              <path d="M393.46 32.2355C393.648 31.9357 393.761 31.5838 393.761 31.2039C393.761 30.1302 392.892 29.259 391.819 29.259C391.179 29.259 390.616 29.5728 390.263 30.051C389.909 29.5728 389.346 29.259 388.706 29.259C387.633 29.259 386.763 30.1292 386.763 31.2039C386.763 31.5838 386.876 31.9367 387.064 32.2355L387.259 32.4901C387.3 32.5362 387.341 32.5813 387.386 32.6234L390.278 35.653L393.152 32.6114C393.187 32.5773 393.219 32.5412 393.252 32.5051L393.46 32.2355Z" fill="#C09CFF"/>
              <path d="M267.706 155.364C267.895 155.064 268.008 154.712 268.008 154.332C268.008 153.258 267.139 152.387 266.065 152.387C265.425 152.387 264.862 152.701 264.508 153.179C264.155 152.701 263.592 152.387 262.952 152.387C261.879 152.387 261.008 153.257 261.008 154.332C261.008 154.712 261.121 155.064 261.31 155.364L261.504 155.618C261.545 155.664 261.586 155.709 261.631 155.752L264.523 158.781L267.398 155.74C267.433 155.705 267.465 155.669 267.498 155.633L267.706 155.364Z" fill="#5F4096"/>
              <path d="M419.545 96.0987C419.733 95.799 419.846 95.4471 419.846 95.0672C419.846 93.9935 418.977 93.1223 417.904 93.1223C417.264 93.1223 416.701 93.4361 416.347 93.9143C415.994 93.4361 415.431 93.1223 414.791 93.1223C413.718 93.1223 412.848 93.9925 412.848 95.0672C412.848 95.4471 412.961 95.8 413.149 96.0987L413.343 96.3534C413.385 96.3995 413.426 96.4446 413.471 96.4867L416.363 99.5163L419.237 96.4747C419.272 96.4406 419.304 96.4045 419.337 96.3684L419.545 96.0987Z" fill="#D2C5EA"/>
              <path d="M553.272 279.463C553.461 279.163 553.574 278.811 553.574 278.431C553.574 277.358 552.704 276.487 551.631 276.487C550.991 276.487 550.428 276.8 550.074 277.279C549.72 276.8 549.158 276.487 548.517 276.487C547.445 276.487 546.574 277.357 546.574 278.431C546.574 278.811 546.687 279.163 546.876 279.463L547.07 279.718C547.111 279.764 547.152 279.809 547.197 279.851L550.089 282.881L552.964 279.839C552.999 279.805 553.031 279.769 553.064 279.733L553.272 279.463Z" fill="#D2C5EA"/>
              <path d="M49.5224 155.364C49.7107 155.064 49.8239 154.712 49.8239 154.332C49.8239 153.258 48.9544 152.387 47.8806 152.387C47.2406 152.387 46.6776 152.701 46.324 153.179C45.9705 152.701 45.4075 152.387 44.7675 152.387C43.6947 152.387 42.8242 153.257 42.8242 154.332C42.8242 154.712 42.9374 155.064 43.1257 155.364L43.32 155.618C43.3611 155.664 43.4022 155.709 43.4473 155.752L46.3391 158.781L49.2139 155.74C49.2489 155.705 49.281 155.669 49.314 155.633L49.5224 155.364Z" fill="#D2C5EA"/>
              <path d="M168.09 118.807C168.516 118.13 168.773 117.333 168.773 116.472C168.773 114.043 166.806 112.073 164.378 112.073C162.93 112.073 161.656 112.783 160.856 113.864C160.055 112.783 158.781 112.073 157.334 112.073C154.907 112.073 152.938 114.043 152.938 116.472C152.938 117.333 153.195 118.13 153.622 118.807L154.061 119.383C154.154 119.487 154.248 119.589 154.35 119.684L160.892 126.539L167.395 119.657C167.475 119.581 167.547 119.499 167.622 119.418L168.09 118.807Z" fill="#8D77B6"/>
              <path d="M180.163 297.669C180.351 297.37 180.464 297.018 180.464 296.638C180.464 295.564 179.595 294.693 178.522 294.693C177.882 294.693 177.319 295.007 176.966 295.485C176.612 295.007 176.049 294.693 175.409 294.693C174.336 294.693 173.467 295.563 173.467 296.638C173.467 297.018 173.58 297.37 173.768 297.669L173.963 297.924C174.004 297.97 174.045 298.015 174.09 298.057L176.982 301.087L179.856 298.045C179.891 298.012 179.924 297.975 179.957 297.939L180.163 297.669Z" fill="#D2C5EA"/>
              <path d="M388.205 136.857C388.582 136.258 388.809 135.554 388.809 134.793C388.809 132.646 387.069 130.905 384.923 130.905C383.643 130.905 382.517 131.532 381.809 132.487C381.101 131.532 379.975 130.905 378.696 130.905C376.55 130.905 374.811 132.646 374.811 134.793C374.811 135.554 375.037 136.258 375.415 136.857L375.803 137.367C375.885 137.459 375.967 137.549 376.058 137.633L381.841 143.693L387.591 137.61C387.662 137.543 387.726 137.471 387.791 137.398L388.205 136.857Z" fill="#C09CFF"/>
              <path d="M320.959 119.327C321.126 119.06 321.227 118.747 321.227 118.408C321.227 117.453 320.453 116.678 319.499 116.678C318.93 116.678 318.429 116.957 318.113 117.382C317.799 116.957 317.298 116.678 316.728 116.678C315.773 116.678 314.999 117.453 314.999 118.408C314.999 118.747 315.1 119.06 315.267 119.327L315.44 119.553C315.476 119.594 315.513 119.634 315.553 119.671L318.126 122.367L320.683 119.66C320.715 119.63 320.744 119.598 320.773 119.566L320.959 119.327Z" fill="#D2C5EA"/>
              <path d="M280.97 41.7101C281.273 41.2299 281.454 40.6655 281.454 40.056C281.454 38.3347 280.06 36.9392 278.34 36.9392C277.314 36.9392 276.412 37.4425 275.844 38.2084C275.277 37.4425 274.374 36.9392 273.348 36.9392C271.628 36.9392 270.233 38.3347 270.233 40.056C270.233 40.6655 270.415 41.2299 270.717 41.7101L271.029 42.1181C271.095 42.1923 271.161 42.2645 271.233 42.3317L275.869 47.1888L280.477 42.3126C280.535 42.2585 280.586 42.2003 280.638 42.1422L280.97 41.7101Z" fill="#8D77B6"/>
              </g>
              <defs>
              <linearGradient id="paint0_linear_4_124" x1="301.911" y1="-69.1855" x2="302.551" y2="469.799" gradientUnits="userSpaceOnUse">
              <stop stop-color="#FBEDC0"/>
              <stop offset="0.3134" stop-color="#988959" stop-opacity="0.2"/>
              <stop offset="0.6955" stop-color="#988959" stop-opacity="0.1"/>
              <stop offset="0.9768" stop-color="#988959" stop-opacity="0.05"/>
              </linearGradient>
              <clipPath id="clip0_4_124">
              <rect width="601" height="401" fill="white"/>
              </clipPath>
              </defs>
              </svg>` +
              "<p class='empty'>" +
              window.wishlist_setup.empty +
              "</p>";
          }
        });
      }
    }
  }
  customElements.define("wishlist-page", WishlistPage);

  document.addEventListener("click", function (e) {
    if (e.target.closest("wishlist-button")) {
      e.target.closest("wishlist-button").classList.add("active");
    } else if (
      !e.target.closest(".wishlist-popup-inner") ||
      e.target.classList.contains("btn-cancel")
    ) {
      document
        .querySelectorAll("[data-wishlist-remove]")
        .forEach(function (el) {
          el.classList.add("inList");
          el.removeAttribute("data-wishlist-remove");
        });
      document.querySelectorAll("[data-wishlist-add]").forEach(function (el) {
        el.classList.remove("inList");
        el.removeAttribute("data-wishlist-add");
      });
      if (document.querySelector("wishlist-button.active"))
        document
          .querySelector("wishlist-button.active")
          .classList.remove("active");
    } else if (e.target.classList.contains("btn-submit")) {
      document
        .querySelectorAll("[data-wishlist-remove]")
        .forEach(function (el) {
          MyWishlist.removeItem(
            el.getAttribute("data-list-id"),
            el.productId,
            el.variantId,
            function (listId, productId, variantId, res) {
              el.classList.remove("inList");
              if (
                !el.closest(".wishlist-navigation").querySelector(".inList")
              ) {
                document
                  .querySelectorAll(
                    '[data-variant-id="' + el.variantId + '"].inList'
                  )
                  .forEach(function (elIn) {
                    elIn.classList.remove("inList");
                  });
              }
            }
          );
        });
      document.querySelectorAll("[data-wishlist-add]").forEach(function (el) {
        MyWishlist.addItem(
          el.getAttribute("data-list-id"),
          el.productId,
          el.variantId,
          function (listId, productId, variantId, res) {
            el.classList.add("inList");
            document
              .querySelectorAll('[data-variant-id="' + el.variantId + '"]')
              .forEach(function (el) {
                el.classList.add("inList");
              });
          }
        );
      });
      document
        .querySelectorAll("[data-wishlist-remove], [data-wishlist-add]")
        .forEach(function (el) {
          el.removeAttribute("data-wishlist-remove");
          el.removeAttribute("data-wishlist-add");
        });
      if (document.querySelector("wishlist-button.active"))
        document
          .querySelector("wishlist-button.active")
          .classList.remove("active");
    }
  });

  class WishlistButton extends HTMLElement {
    constructor() {
      super();
      let _this = this;
      _this.button = this;
      _this.variantId = this.getAttribute("data-variant-id");
      _this.productId = this.getAttribute("data-product-id");

      if (_this.getAttribute("data-list-id")) {
        // List page
        _this.addEventListener("click", function (e) {
          e.preventDefault();
          if (_this.classList.contains("inList")) {
            _this.classList.remove("inList");
            MyWishlist.removeItem(
              _this.getAttribute("data-list-id"),
              _this.productId,
              _this.variantId
            );
            if (!MyWishlist.isPreview) _this.closest(".product-block").remove();
          } else {
            //_this.classList.add("inList");
            MyWishlist.addItem(
              _this.getAttribute("data-list-id"),
              _this.productId,
              _this.variantId,
              function (listId, productId, variantId, res) {}
            );
          }
          return false;
        });

        _this.renderButton();
      } else {
        // Other pages

        _this.renderButton();
      }

      window.addEventListener("wishlist:update", function () {
        _this.renderButton();
      });
    }
    renderButton() {
      let _this = this;
      if (!_this) return;
      let data = MyWishlist.getData();
      let isInList = false;
      if (data) {
        let keys = Object.keys(data);
        keys.forEach(function (key) {
          let keyData = data[key]["data"];
          if (keyData && keyData.length) {
            keyData.forEach(function (el) {
              if (
                !isInList &&
                el &&
                el.variant_id &&
                el.variant_id == _this.variantId
              ) {
                isInList = true;
              }
            });
          }
        });
        if (_this.button && _this.button.classList) {
          if (isInList) {
            _this.button.classList.add("inList");
          } else {
            _this.button.classList.remove("inList");
          }
        }
      }
    }
  }
  customElements.define("wishlist-button", WishlistButton);

  class WishlistItemList extends HTMLElement {
    constructor() {
      super();
      let data = MyWishlist.getData();
      let _this = this;
      _this.variantId = _this
        .closest("[data-variant-id]")
        .getAttribute("data-variant-id");
      _this.productId = _this
        .closest("[data-product-id]")
        .getAttribute("data-product-id");
      let listId = parseInt(_this.getAttribute("data-list-id"));
      let thisFullList = data[listId]["data"] ? data[listId]["data"] : [];
      let isInList = false;
      thisFullList.forEach(function (listEl) {
        if (
          !isInList &&
          listEl &&
          listEl.variant_id &&
          listEl.variant_id == _this.variantId
        ) {
          isInList = true;
        }
      });
      if (isInList) {
        _this.classList.add("inList");
      } else {
        _this.classList.remove("inList");
      }

      _this.addEventListener("click", function (e) {
        e.preventDefault();
        if (_this.classList.contains("inList")) {
          _this.classList.remove("inList");
          _this.setAttribute("data-wishlist-remove", 1);
        } else {
          _this.classList.add("inList");
          _this.setAttribute("data-wishlist-add", 1);
        }
      });
    }
  }
  customElements.define("wishlist-item-list", WishlistItemList);

  class WishlistMainButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", function () {
        this.classList.toggle("active");
      });
    }
  }
  customElements.define("wishlist-main-button", WishlistMainButton);

  class WishlistAddList extends HTMLElement {
    constructor() {
      super();
      let isPage = this.getAttribute("data-page");
      let form = this.querySelector("form");
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        let listName = this.querySelector("input").value;
        MyWishlist.addList(listName, function (res) {
          if (isPage) {
            setTimeout(function () {
              window.location = "/pages/wishlist";
            }, 400);
          } else {
            if (form.closest("wishlist-navigation.wishlist-popup")) {
              let btn = form.closest(
                "wishlist-navigation.wishlist-popup"
              ).previousElementSibling;
              setTimeout(function () {
                btn.classList.add("active");
              }, 400);
            }
          }
        });
        return false;
      });
    }
  }

  customElements.define("wishlist-add-list", WishlistAddList);

  class WishlistRemoveList extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", function (e) {
        e.preventDefault();
        let listId = this.getAttribute("data-list-id");
        MyWishlist.deleteList(listId, function (listId, res) {
          setTimeout(function () {
            window.location = "/pages/wishlist";
          }, 400);
        });
        return false;
      });
    }
  }

  customElements.define("wishlist-remove-list", WishlistRemoveList);

  class WishlistEditList extends HTMLElement {
    constructor() {
      super();
      let listId = this.getAttribute("data-list-id");
      let form = this.querySelector("form");
      let input = form.querySelector("input");
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        MyWishlist.updateList(input.value, listId, function (listName, res) {
          setTimeout(function () {
            window.location = "/pages/wishlist?list=" + listId;
          }, 400);
        });
        return false;
      });
    }
  }

  customElements.define("wishlist-edit-list", WishlistEditList);
});
